import { useSearchParams } from "react-router-dom";
import TopMenuStrip from "../../../shared/components/TopMenuStrip";
import ContactList from "../components/ContactList";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";
import "../styles/adminContactStyles.css";
import useUserContextStore from "../../../store/userContextStore";
import { useEffect } from "react";

const AdminContactPage = () => {
  useDocumentTitle('Admin Contact')
  const [params] = useSearchParams();
  const mode = params.get("mode");
  const contactId = params.get("id");
  const setUserContext = useUserContextStore((state)=>state.setUserContext);
  const context = useUserContextStore((state)=> state.context);
  useEffect(()=>{
    if(context){
      setUserContext(null)
    }
  },[context])

  return (
    <ContactList />

  );
};

export default AdminContactPage;